"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8345],{

/***/ 32685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25241);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97702);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function DenomIcon(_ref) {
  var denomInfo = _ref.denomInfo,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 4 : _ref$size,
      _ref$showTooltip = _ref.showTooltip,
      showTooltip = _ref$showTooltip === void 0 ? false : _ref$showTooltip;

  if (!denomInfo) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .SkeletonCircle */ .s, {
      width: size,
      height: size
    });
  }

  var name = denomInfo.name,
      icon = denomInfo.icon,
      id = denomInfo.id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tooltip */ .u, {
    label: name,
    isDisabled: !showTooltip,
    children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
      "data-testid": "denom-icon-".concat(id),
      display: "inline",
      src: icon,
      width: size,
      height: size
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
      fontSize: "xs",
      textTransform: "capitalize",
      borderRadius: "full",
      bg: "black",
      width: size,
      height: size,
      textAlign: "center",
      lineHeight: 1.3,
      cursor: "default",
      children: (name === null || name === void 0 ? void 0 : name.charAt(0)) || '?'
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (DenomIcon);

/***/ }),

/***/ 95709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ TransactionType; }
/* harmony export */ });
var TransactionType;

(function (TransactionType) {
  TransactionType["Buy"] = "buy";
  TransactionType["Sell"] = "sell";
})(TransactionType || (TransactionType = {}));

/***/ }),

/***/ 99316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ combineDateAndTime; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16835);

function combineDateAndTime(startDate, purchaseTime) {
  var startTime = new Date(startDate);

  if (purchaseTime) {
    var _purchaseTime$split = purchaseTime.split(':'),
        _purchaseTime$split2 = (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_purchaseTime$split, 2),
        hours = _purchaseTime$split2[0],
        minutes = _purchaseTime$split2[1];

    startTime.setHours(parseInt(hours, 10));
    startTime.setMinutes(parseInt(minutes, 10));
  }

  return startTime;
}

/***/ }),

/***/ 89601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ allSchema; },
/* harmony export */   "D0": function() { return /* binding */ postPurchaseValidationSchema; },
/* harmony export */   "Qg": function() { return /* binding */ step1ValidationSchema; },
/* harmony export */   "SY": function() { return /* binding */ step2ValidationSchema; },
/* harmony export */   "Sc": function() { return /* binding */ initialValues; },
/* harmony export */   "oP": function() { return /* binding */ simplifiedDcaInValidationSchema; },
/* harmony export */   "rL": function() { return /* binding */ dcaSchema; },
/* harmony export */   "ry": function() { return /* binding */ assetsFormInitialValues; },
/* harmony export */   "sg": function() { return /* binding */ denomInfoSchema; },
/* harmony export */   "yL": function() { return /* binding */ assetsFormSchema; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var src_models_TriggerTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71590);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74231);
/* harmony import */ var _helpers_combineDateAndTime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99316);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18459);
/* harmony import */ var _helpers_chains__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87038);
/* harmony import */ var _YesNoValues__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29858);
/* harmony import */ var _StrategyType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94705);
/* harmony import */ var _PostPurchaseOptions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74973);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var assetsFormInitialValues = {
  strategyType: '',
  initialDenom: undefined,
  resultingDenom: undefined,
  initialDeposit: null
};
var denomInfoSchema = {
  id: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required(),
  name: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required(),
  coingeckoId: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required().label('Coingecko ID'),
  icon: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required(),
  minimumSwapAmount: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().required(),
  chain: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required(),
  stakeable: yup__WEBPACK_IMPORTED_MODULE_2__/* .boolean */ .O7().required(),
  stable: yup__WEBPACK_IMPORTED_MODULE_2__/* .boolean */ .O7().required(),
  stakeableAndSupported: yup__WEBPACK_IMPORTED_MODULE_2__/* .boolean */ .O7().required(),
  enabled: yup__WEBPACK_IMPORTED_MODULE_2__/* .boolean */ .O7().required(),
  significantFigures: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().required(),
  enabledInDcaPlus: yup__WEBPACK_IMPORTED_MODULE_2__/* .boolean */ .O7().required(),
  pricePrecision: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().required()
};
var assetsFormSchema = yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry({
  strategyType: yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK().required(),
  resultingDenom: yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry(_objectSpread(_objectSpread({}, denomInfoSchema), {}, {
    coingeckoId: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().notRequired()
  })).label('Resulting Denom'),
  initialDenom: yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry(denomInfoSchema).label('Initial Denom'),
  initialDeposit: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().label('Initial Deposit').positive().required().nullable().test({
    name: 'less-than-balance',
    message: function message(_ref) {
      var label = _ref.label;
      return "".concat(label, " must be less than or equal to than your current balance");
    },
    test: function test(value, context) {
      var _context$options, _context$options$cont, _balances$find;

      var balances = context === null || context === void 0 ? void 0 : (_context$options = context.options) === null || _context$options === void 0 ? void 0 : (_context$options$cont = _context$options.context) === null || _context$options$cont === void 0 ? void 0 : _context$options$cont.balances;
      if (!balances || !value || value <= 0) return true;
      var balance = (_balances$find = balances.find(function (b) {
        var _context$parent$initi;

        return b.denom === ((_context$parent$initi = context.parent.initialDenom) === null || _context$parent$initi === void 0 ? void 0 : _context$parent$initi.id);
      })) === null || _balances$find === void 0 ? void 0 : _balances$find.amount;
      return balance && value <= Number(balance);
    }
  }).test({
    name: 'greater-than-minimum-deposit',
    test: function test(value, context) {
      if ((0,lodash__WEBPACK_IMPORTED_MODULE_3__.isNil)(value)) return true;

      var _context$parent$conte = _objectSpread(_objectSpread({}, context.parent), context.options.context),
          _context$parent$conte2 = _context$parent$conte.initialDenom,
          initialDenom = _context$parent$conte2 === void 0 ? null : _context$parent$conte2,
          _context$parent$conte3 = _context$parent$conte.strategyType,
          strategyType = _context$parent$conte3 === void 0 ? null : _context$parent$conte3;

      if (!initialDenom) return true;
      if (strategyType !== _StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.DCAPlusIn */ .h.DCAPlusIn && strategyType !== _StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.DCAPlusOut */ .h.DCAPlusOut) return true;
      var _initialDenom$minimum = initialDenom.minimumSwapAmount,
          minimumSwapAmount = _initialDenom$minimum === void 0 ? 0 : _initialDenom$minimum;
      var dcaPlusMinimumDeposit = minimumSwapAmount * src_constants__WEBPACK_IMPORTED_MODULE_4__/* .DCA_PLUS_MIN_SWAP_COEFFICIENT */ .V4 * src_constants__WEBPACK_IMPORTED_MODULE_4__/* .MIN_DCA_PLUS_STRATEGY_DURATION */ .o1;
      if (value > dcaPlusMinimumDeposit) return true;
      return context.createError({
        message: "Initial deposit must be more than ".concat(dcaPlusMinimumDeposit, " ").concat(initialDenom.name, ", otherwise the minimum swap amount will decay performance. We recommend depositing at least $50 worth of assets.")
      });
    }
  })
});
var initialValues = {
  resultingDenom: undefined,
  initialDenom: undefined,
  initialDeposit: null,
  advancedSettings: false,
  startImmediately: _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Yes */ .Z.Yes,
  triggerType: src_models_TriggerTypes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Date */ .Z.Date,
  startDate: null,
  purchaseTime: '',
  startPrice: null,
  executionInterval: 'daily',
  executionIntervalIncrement: 1,
  swapAmount: null,
  slippageTolerance: 2,
  priceThresholdEnabled: _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].No */ .Z.No,
  priceThresholdValue: null,
  sendToWallet: _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Yes */ .Z.Yes,
  recipientAccount: '',
  autoStakeValidator: '',
  autoCompoundStakingRewards: true,
  strategyDuration: 60,
  postPurchaseOption: _PostPurchaseOptions__WEBPACK_IMPORTED_MODULE_8__/* .PostPurchaseOptions.SendToWallet */ .S.SendToWallet,
  yieldOption: null,
  reinvestStrategy: '',
  basePriceIsCurrentPrice: _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Yes */ .Z.Yes,
  basePriceValue: null,
  swapMultiplier: 1,
  applyMultiplier: _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Yes */ .Z.Yes
};
var timeFormat = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;
var allSchema = {
  resultingDenom: yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry(_objectSpread(_objectSpread({}, denomInfoSchema), {}, {
    coingeckoId: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().notRequired()
  })).label('Resulting Denom').required(),
  initialDenom: yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry(denomInfoSchema).label('Initial Denom').required(),
  initialDeposit: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().label('Initial Deposit').positive().required().nullable().test({
    name: 'less-than-deposit',
    message: function message(_ref2) {
      var label = _ref2.label;
      return "".concat(label, " must be less than or equal to than your current balance");
    },
    test: function test(value, context) {
      var _context$options2, _context$options2$con, _balances$find2;

      var balances = context === null || context === void 0 ? void 0 : (_context$options2 = context.options) === null || _context$options2 === void 0 ? void 0 : (_context$options2$con = _context$options2.context) === null || _context$options2$con === void 0 ? void 0 : _context$options2$con.balances;
      if (!balances || !value || value <= 0) return true;
      var balance = (_balances$find2 = balances.find(function (b) {
        var _context$parent$initi2;

        return b.denom === ((_context$parent$initi2 = context.parent.initialDenom) === null || _context$parent$initi2 === void 0 ? void 0 : _context$parent$initi2.id);
      })) === null || _balances$find2 === void 0 ? void 0 : _balances$find2.amount;
      return balance && value <= Number(balance);
    }
  }),
  advancedSettings: yup__WEBPACK_IMPORTED_MODULE_2__/* .boolean */ .O7(),
  startImmediately: yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK().oneOf(Object.values(_YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)).required(),
  triggerType: yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK().oneOf(Object.values(src_models_TriggerTypes__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)).required().when('startImmediately', {
    is: _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Yes */ .Z.Yes,
    then: function then(schema) {
      return schema.transform(function () {
        return src_models_TriggerTypes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Date */ .Z.Date;
      });
    }
  }),
  startDate: yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK().label('Start Date').nullable().when(['startImmediately', 'triggerType', 'advancedSettings'], function (startImmediately, triggerType, advancedSettings, schema) {
    if (triggerType === src_models_TriggerTypes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Date */ .Z.Date && startImmediately === _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].No */ .Z.No) {
      var minDate = advancedSettings ? new Date(new Date().setDate(new Date().getDate() - 1)) : new Date();
      return yup__WEBPACK_IMPORTED_MODULE_2__/* .date */ .hT().label('Start Date').nullable().min(minDate, function (_ref3) {
        var label = _ref3.label;
        return "".concat(label, " must be in the future.");
      }).required();
    }

    return schema.transform(function () {
      return null;
    });
  }),
  startPrice: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().label('Start Price').positive().nullable().when(['startImmediately', 'triggerType'], {
    is: function is(startImmediately, triggerType) {
      return triggerType === src_models_TriggerTypes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Price */ .Z.Price && startImmediately === _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].No */ .Z.No;
    },
    then: function then(schema) {
      return schema.required();
    },
    otherwise: function otherwise(schema) {
      return schema.transform(function () {
        return null;
      });
    }
  }),
  purchaseTime: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().label('Purchase Time').matches(timeFormat, {
    excludeEmptyString: true,
    message: function message(_ref4) {
      var label = _ref4.label;
      return "".concat(label, " must be in the format HH:MM (24 hour time)");
    }
  }).when(['advancedSettings', 'startImmediately', 'triggerType'], {
    is: function is(advancedSettings, startImmediately, triggerType) {
      return triggerType === src_models_TriggerTypes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Date */ .Z.Date && advancedSettings === true && startImmediately === _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].No */ .Z.No;
    },
    then: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required(),
    otherwise: function otherwise(schema) {
      return schema.transform(function () {
        return '';
      });
    }
  }).test({
    name: 'time-is-in-past',
    message: 'Date and time must be in the future',
    test: function test(value, context) {
      if (!(value !== null && value !== void 0 && value.match(timeFormat))) return true;

      var _context$parent = _objectSpread({}, context.parent),
          _context$parent$start = _context$parent.startDate,
          startDate = _context$parent$start === void 0 ? new Date() : _context$parent$start;

      if (!value || !startDate) return false;
      return new Date() <= (0,_helpers_combineDateAndTime__WEBPACK_IMPORTED_MODULE_9__/* .combineDateAndTime */ .Z)(startDate, value);
    }
  }),
  route: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_(),
  executionInterval: yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK().required(),
  executionIntervalIncrement: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().label('Increment').required().positive().integer().nullable().transform(function (value, originalValue) {
    if (originalValue === '') {
      return null;
    }

    return value;
  }),
  swapAmount: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().label('Swap Amount').required().nullable().transform(function (value, originalValue) {
    return originalValue === '' ? null : value;
  }).test({
    name: 'less-than-deposit',
    message: 'Swap amount must be less than initial deposit',
    test: function test(value, context) {
      var _context$parent$conte4 = _objectSpread(_objectSpread({}, context.parent), context.options.context),
          _context$parent$conte5 = _context$parent$conte4.initialDeposit,
          initialDeposit = _context$parent$conte5 === void 0 ? 0 : _context$parent$conte5;

      if (!value) return true;
      return value <= initialDeposit;
    }
  }).test({
    name: 'greater-than-minimum-swap',
    test: function test(value, context) {
      if (false) {}
      if ((0,lodash__WEBPACK_IMPORTED_MODULE_3__.isNil)(value)) return true;

      var _context$parent$conte6 = _objectSpread(_objectSpread({}, context.parent), context.options.context),
          _context$parent$conte7 = _context$parent$conte6.initialDenom,
          initialDenom = _context$parent$conte7 === void 0 ? null : _context$parent$conte7;

      if (!initialDenom) return true;
      var _initialDenom$minimum2 = initialDenom.minimumSwapAmount,
          minimumSwapAmount = _initialDenom$minimum2 === void 0 ? 0 : _initialDenom$minimum2;
      if (value > minimumSwapAmount) return true;
      return context.createError({
        message: "Swap amount should be greater than ".concat(minimumSwapAmount)
      });
    }
  }),
  slippageTolerance: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().label('Slippage Tolerance').lessThan(100).min(0)["default"](initialValues.slippageTolerance).when('advancedSettings', {
    is: true,
    then: function then(schema) {
      return schema.required();
    },
    otherwise: function otherwise(schema) {
      return schema.transform(function () {
        return initialValues.slippageTolerance;
      });
    }
  }),
  priceThresholdEnabled: yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK().oneOf(Object.values(_YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)).required().when('advancedSettings', {
    is: false,
    then: function then(schema) {
      return schema.transform(function () {
        return _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].No */ .Z.No;
      });
    }
  }),
  priceThresholdValue: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().nullable().label('Price Threshold').positive().when(['advancedSettings', 'priceThresholdEnabled'], {
    is: function is(advancedSettings, priceThresholdEnabled) {
      return advancedSettings === true && priceThresholdEnabled === _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Yes */ .Z.Yes;
    },
    then: function then(schema) {
      return schema.required();
    },
    otherwise: function otherwise(schema) {
      return schema.transform(function () {
        return null;
      });
    }
  }).test({
    name: 'less-than-price-trigger',
    message: 'Price ceiling must be greater than or equal to price trigger',
    test: function test(value, context) {
      if (!value) return true;

      var _context$parent$conte8 = _objectSpread(_objectSpread({}, context.parent), context.options.context),
          _context$parent$conte9 = _context$parent$conte8.startPrice,
          startPrice = _context$parent$conte9 === void 0 ? undefined : _context$parent$conte9,
          _context$parent$conte10 = _context$parent$conte8.strategyType,
          strategyType = _context$parent$conte10 === void 0 ? undefined : _context$parent$conte10;

      if (!startPrice) return true;
      if (strategyType !== _StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.DCAIn */ .h.DCAIn && strategyType !== _StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.WeightedScaleIn */ .h.WeightedScaleIn) return true;
      return value >= startPrice;
    }
  }).test({
    name: 'greater-than-price-trigger',
    message: 'Price floor must be less than or equal to price trigger',
    test: function test(value, context) {
      if (!value) return true;

      var _context$parent$conte11 = _objectSpread(_objectSpread({}, context.parent), context.options.context),
          _context$parent$conte12 = _context$parent$conte11.startPrice,
          startPrice = _context$parent$conte12 === void 0 ? undefined : _context$parent$conte12,
          _context$parent$conte13 = _context$parent$conte11.strategyType,
          strategyType = _context$parent$conte13 === void 0 ? undefined : _context$parent$conte13;

      if (!startPrice) return true;
      if (strategyType !== _StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.DCAOut */ .h.DCAOut && strategyType !== _StrategyType__WEBPACK_IMPORTED_MODULE_7__/* .StrategyType.WeightedScaleOut */ .h.WeightedScaleOut) return true;
      return value <= startPrice;
    }
  }),
  postPurchaseOption: yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK(),
  sendToWallet: yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK().oneOf(Object.values(_YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)).required().when('postPurchaseOption', {
    is: _PostPurchaseOptions__WEBPACK_IMPORTED_MODULE_8__/* .PostPurchaseOptions.SendToWallet */ .S.SendToWallet,
    then: function then(schema) {
      return schema;
    },
    otherwise: function otherwise(schema) {
      return schema.transform(function () {
        return _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Yes */ .Z.Yes;
      });
    }
  }),
  recipientAccount: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().label('Recipient Account').nullable().when('sendToWallet', {
    is: _YesNoValues__WEBPACK_IMPORTED_MODULE_6__/* ["default"].No */ .Z.No,
    then: function then(schema) {
      return schema.required();
    },
    otherwise: function otherwise(schema) {
      return schema.transform(function () {
        return '';
      });
    }
  }).test({
    name: 'correct-length',
    message: function message(_ref5) {
      var label = _ref5.label;
      return "".concat(label, " is not a valid address");
    },
    test: function test(value, context) {
      if (!value) return true;

      var _ref6 = context.options.context || {},
          chain = _ref6.chain;

      if (!chain) return true;
      return (0,_helpers_chains__WEBPACK_IMPORTED_MODULE_5__/* .getChainAddressLength */ .zd)(chain).includes(value.length);
    }
  }).test({
    name: 'starts-with-chain-prefix',
    message: function message(_ref7) {
      var label = _ref7.label;
      return "".concat(label, " has an invalid prefix");
    },
    test: function test(value, context) {
      if (!value) return true;

      var _ref8 = context.options.context || {},
          chain = _ref8.chain;

      if (!chain) return true;
      return value === null || value === void 0 ? void 0 : value.startsWith((0,_helpers_chains__WEBPACK_IMPORTED_MODULE_5__/* .getAddressPrefix */ .UF)(chain));
    }
  }),
  autoStakeValidator: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().label('Validator').nullable().when(['postPurchaseOption'], {
    is: _PostPurchaseOptions__WEBPACK_IMPORTED_MODULE_8__/* .PostPurchaseOptions.Stake */ .S.Stake,
    then: function then(schema) {
      return schema.required();
    },
    otherwise: function otherwise(schema) {
      return schema.transform(function () {
        return null;
      });
    }
  }),
  autoCompoundStakingRewards: yup__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg().label('Auto-compound Staking Rewards'),
  yieldOption: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().label('Yield Option').nullable().when('postPurchaseOption', {
    is: _PostPurchaseOptions__WEBPACK_IMPORTED_MODULE_8__/* .PostPurchaseOptions.GenerateYield */ .S.GenerateYield,
    then: function then(schema) {
      return schema.required();
    },
    otherwise: function otherwise(schema) {
      return schema.transform(function () {
        return null;
      });
    }
  }),
  reinvestStrategy: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().label('Reinvest Strategy').nullable().when('postPurchaseOption', {
    is: _PostPurchaseOptions__WEBPACK_IMPORTED_MODULE_8__/* .PostPurchaseOptions.Reinvest */ .S.Reinvest,
    then: function then(schema) {
      return schema.required();
    },
    otherwise: function otherwise(schema) {
      return schema.transform(function () {
        return null;
      });
    }
  }),
  strategyDuration: yup__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx().label('Strategy Duration').min(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .MIN_DCA_PLUS_STRATEGY_DURATION */ .o1).max(src_constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_DCA_PLUS_STRATEGY_DURATION */ .$o).required().nullable().test({
    name: 'swaps-greater-than-minimum',
    test: function test(value, context) {
      if ((0,lodash__WEBPACK_IMPORTED_MODULE_3__.isNil)(value)) return true;

      var _context$parent$conte14 = _objectSpread(_objectSpread({}, context.parent), context.options.context),
          _context$parent$conte15 = _context$parent$conte14.initialDenom,
          initialDenom = _context$parent$conte15 === void 0 ? null : _context$parent$conte15,
          _context$parent$conte16 = _context$parent$conte14.initialDeposit,
          initialDeposit = _context$parent$conte16 === void 0 ? null : _context$parent$conte16;

      if (!initialDenom || !initialDeposit) return true;
      var _initialDenom$minimum3 = initialDenom.minimumSwapAmount,
          minimumSwapAmount = _initialDenom$minimum3 === void 0 ? 0 : _initialDenom$minimum3;
      var maximumDurationFromDeposit = Math.ceil(initialDeposit / (minimumSwapAmount * src_constants__WEBPACK_IMPORTED_MODULE_4__/* .DCA_PLUS_MIN_SWAP_COEFFICIENT */ .V4));
      if (value < maximumDurationFromDeposit) return true;
      return context.createError({
        message: "Duration must be less than ".concat(maximumDurationFromDeposit, " days. Increase your initial deposit to allow for a longer duration.")
      });
    }
  })
};
var dcaSchema = yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry({
  resultingDenom: allSchema.resultingDenom,
  initialDenom: allSchema.initialDenom,
  initialDeposit: allSchema.initialDeposit,
  advancedSettings: allSchema.advancedSettings,
  startImmediately: allSchema.startImmediately,
  triggerType: allSchema.triggerType,
  startDate: allSchema.startDate,
  startPrice: allSchema.startPrice,
  purchaseTime: allSchema.purchaseTime,
  route: allSchema.route,
  executionInterval: allSchema.executionInterval,
  executionIntervalIncrement: allSchema.executionIntervalIncrement,
  swapAmount: allSchema.swapAmount,
  slippageTolerance: allSchema.slippageTolerance,
  priceThresholdEnabled: allSchema.priceThresholdEnabled,
  priceThresholdValue: allSchema.priceThresholdValue,
  sendToWallet: allSchema.sendToWallet,
  recipientAccount: allSchema.recipientAccount,
  autoStakeValidator: allSchema.autoStakeValidator,
  autoCompoundStakingRewards: allSchema.autoCompoundStakingRewards,
  postPurchaseOption: allSchema.postPurchaseOption,
  yieldOption: allSchema.yieldOption,
  reinvestStrategy: allSchema.reinvestStrategy
});
var step1ValidationSchema = yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry({
  resultingDenom: allSchema.resultingDenom,
  initialDenom: allSchema.initialDenom,
  initialDeposit: allSchema.initialDeposit,
  route: allSchema.route
});
var postPurchaseValidationSchema = dcaSchema.pick(['postPurchaseOption', 'sendToWallet', 'recipientAccount', 'autoStakeValidator', 'autoCompoundStakingRewards', 'yieldOption', 'reinvestStrategy']);
var step2ValidationSchema = dcaSchema.pick(['advancedSettings', 'startImmediately', 'triggerType', 'route', 'startDate', 'startPrice', 'purchaseTime', 'executionInterval', 'executionIntervalIncrement', 'swapAmount', 'slippageTolerance', 'priceThresholdEnabled', 'priceThresholdValue']);
var simplifiedDcaInValidationSchema = dcaSchema.pick(['initialDenom', 'resultingDenom', 'swapAmount', 'route', 'initialDeposit', 'executionInterval', 'executionIntervalIncrement', 'sendToWallet']);

/***/ }),

/***/ 74973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ PostPurchaseOptions; }
/* harmony export */ });
var PostPurchaseOptions;

(function (PostPurchaseOptions) {
  PostPurchaseOptions["SendToWallet"] = "sendToWallet";
  PostPurchaseOptions["Stake"] = "stake";
  PostPurchaseOptions["Reinvest"] = "reinvest";
  PostPurchaseOptions["GenerateYield"] = "generateYield";
})(PostPurchaseOptions || (PostPurchaseOptions = {}));

/***/ }),

/***/ 94705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ StrategyType; }
/* harmony export */ });
var StrategyType;

(function (StrategyType) {
  StrategyType["SimpleDCAIn"] = "Simple DCA In";
  StrategyType["DCAIn"] = "DCA In";
  StrategyType["DCAOut"] = "DCA Out";
  StrategyType["DCAPlusIn"] = "DCA+ In";
  StrategyType["DCAPlusOut"] = "DCA+ Out";
  StrategyType["WeightedScaleIn"] = "Weighted Scale In";
  StrategyType["WeightedScaleOut"] = "Weighted Scale Out";
  StrategyType["StreamingSwap"] = "Streaming Swap";
})(StrategyType || (StrategyType = {}));

/***/ }),

/***/ 71590:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var TriggerTypes;

(function (TriggerTypes) {
  TriggerTypes["Date"] = "date";
  TriggerTypes["Price"] = "price";
})(TriggerTypes || (TriggerTypes = {}));

/* harmony default export */ __webpack_exports__["Z"] = (TriggerTypes);

/***/ }),

/***/ 29858:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var YesNoValues;

(function (YesNoValues) {
  YesNoValues["Yes"] = "yes";
  YesNoValues["No"] = "no";
})(YesNoValues || (YesNoValues = {}));

/* harmony default export */ __webpack_exports__["Z"] = (YesNoValues);

/***/ })

}]);